export const GET_TRANSACTION = 'BTAX/get_transaction';
export const APPROVE_TRANSACTION = 'BTAX/approve_transaction';
export const UPDATE_TRANSACTION = 'BTAX/update_transaction';
export const SHOW_TRANSACTION = 'BTAX/show_transaction';
export const START_ASSESSMENT = 'BTAX/start_assessment';
export const GET_SETTINGS = 'BTAX/get_settings';
export const UPDATE_TEST_STATUS = 'BTAX/update_health_status';
export const ASSESS_RECEIPT = 'BIRTH_CERTIFICATES/assess_receipt';
export const OCCUPATIONAL_PERMIT_URI =
  'api/v1/administrators/occupational_permit/';
export const HEALTH_CERTIFICATE_URI =
  'api/v1/administrators/health_certificate/';

export const DEPENDENCIES = {
  health_certificate_amount: {
    label: 'Health Certificate',
  },
  occupational_permit_amount: {
    label: 'Occupational Permit',
  },
  card_type: {
    label: 'CARD TYPE',
  },
  stool_amount: {
    label: 'Stool',
  },
  sputum_amount: {
    label: 'Sputum',
  },
  drug_test_amount: {
    label: 'Drug Test',
  },
  rpr_syphilis_amount: {
    label: 'RPR Syphilis',
  },
  gram_stain: {
    label: 'Gram Stain',
  },
};

export const FORM_DATA = {
  status: 'REJECT',
  remarks: '',
};
